import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import './index.scss';

import * as Actions from '../../../redux/actions';

//assets
import arrow from 'assets/icons/arrow-white.svg';
import lock from 'assets/icons/lock.svg';
import fire from 'assets/icons/fire.svg';
import {formatNumber, getMediaPath} from "../../../app/functions";

import * as Popups from "../../../constants/popup-types";

const OrderConclusion = (props) =>{

    const text = useSelector(store => store.config.Translations);

    const dispatch = useDispatch();

    const deviceState = useSelector(store => store.state.deviceState);
    const cart = useSelector(store => store.config.Cart);
    // const benefit = useSelector(store => store.data.BenefitPage);
    const TradeBenefitsChargeTypes = useSelector(store => store.config.TradeBenefitsChargeTypes);

    const isDesktop = deviceState === 'desktop' || deviceState === 'desktop-large';

    const getProductQuantity = () =>{
        let quantity = 0;

        for (let key in cart.itemsArr){
            quantity += parseInt(cart.itemsArr[key]?.quantity);
        }

        return quantity;
    };

    const isCashBack = () =>{
        let trade_charge_type = -1;

        for(let key in cart.itemsArr){
            trade_charge_type = cart.itemsArr[key].trade_charge_type;
        }

        const tradeBenefitsChargeTypes = TradeBenefitsChargeTypes;// from generalDeclaration
        return tradeBenefitsChargeTypes[trade_charge_type] === "cashback"
    }

    let cashback_description = "";
    for(let key in cart.itemsArr){
        cashback_description = cart.itemsArr[key].cashback_description;
    }

    return(
        <section className='order-conclusion'>
            {/*<div className='coupon-wrapper'>*/}
                {/*<input type='text' placeholder={text['payment_coupon_placeholder']}/>*/}
                {/*<div className='image-wrapper'><img src={arrow} alt=''/></div>*/}
            {/*</div>*/}

            <div className='conclusion'>
                {!isDesktop &&
                <div className='head'>
                    <span className='title'>{text['payment_conc_title']}</span>
                    <div className='security'>
                        <span>{text['payment_conc_security']}</span>
                        <img src={getMediaPath(lock)} alt=''/>
                    </div>
                </div>
                }
                <div className='prices'>
                    <div className='price-wrap'>
                        <span className='text'>{text['payment_conc_old_price']}</span>
                        <span className='price'>{formatNumber(cart.total_sum_before)}</span>
                    </div>
                    <div className='price-wrap'>
                        <span className='text'>{text['payment_conc_discount']}</span>
                        <span className='price no-symbol'>{formatNumber(getProductQuantity())}</span>
                    </div>
                    {cart.total_delivery_cost > 0 &&
                    <div className='price-wrap'>
                        <span className='text'>{text['payment_conc_delivery_price']}</span>
                        <span className='price'>{formatNumber(cart.total_delivery_cost)}</span>
                    </div>
                    }
                    <div className='price-wrap'>
                        <span className='text'>{text['payment_conc_price']}</span>
                        <span className='price'>{formatNumber(cart.total_sum)}</span>
                    </div>
                </div>
                { isCashBack() &&
                <div className="cash-back-wrapper">
                    <p className="cash-back-text">{cashback_description}</p>
                </div>

                }
                {cart.total_discount !== null &&
                    <div className='saving-wrapper'>
                    <img src={getMediaPath(fire)} alt=''/>
                    <span>{text['conclusion_savings'] + ' ' + formatNumber(cart.total_discount)}</span>
                </div>}

                <div className='submit-wrapper'>
                    {!isDesktop && <span>{text['payment_pay'] + cart.total_sum }</span>}
                    {isDesktop &&
                    <div className='security'>
                        <span>{text['payment_conc_security']}</span>
                        <img src={getMediaPath(lock)} alt=''/>
                    </div>}
                    <button className='submit-btn' onClick={props.onDoPayment}>{text['payment_submit']}</button>
                </div>
            </div>
        </section>
    )
};

export default OrderConclusion;